"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const winterMaintanceService = {
  getWinterAreas: function (isExtended) {
    return api.get("/WinterAreas", WithToken.headersToken({ params: { isExtended: isExtended } }, configuration.cookieName));
  },
  getWinterCompaniesRoutes: function (id, options) {
    return api.post(`/WinterCompanies/${id}/Routes`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  /*   getWinterReportsDownload: function (options) {
    return api.get(`/WinterReports/Download`, WithToken.headersToken({ params: options }, configuration.cookieName));
  }, */
  getWinterReportsDownload: function (options) {
    return api.get(`/Download`, WithToken.headersToken({ params: options, responseType: "blob" }, configuration.cookieName));
  },
  getWinterEOSKReportsDownload: function (options) {
    return api.post(`/EOSK/Download`, options, WithToken.headersToken({ responseType: "blob" }, configuration.cookieName));
  },
  getWinterShortEOSKReportsDownload: function (options) {
    return api.post(`/EOSK/Short/Download`, options, WithToken.headersToken({ responseType: "blob" }, configuration.cookieName));
  },
};

export default winterMaintanceService;
